import { errorFourSvgData } from '../../../../Data/OtherPage/OtherPage'
import CommonError from '../Common/CommonError'

const Error404Container = () => {
  return (
    <CommonError errorSvg={errorFourSvgData} />
  )
}

export default Error404Container